module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_サービスの安定性No.1-fdfbf8567998101052f755bf11ee2d7a.png";